import FormattedMessage from 'I18n/components/FormattedMessage';
import Code from 'UIComponents/elements/Code';
import H7 from 'UIComponents/elements/headings/H7';
import UIDescriptionList from 'UIComponents/list/UIDescriptionList';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TokenDescription = ({
  title,
  label,
  type,
  name
}) => {
  return /*#__PURE__*/_jsxs(View, {
    as: "div",
    margin: "400",
    inlineSize: "200px",
    children: [/*#__PURE__*/_jsx(H7, {
      children: title
    }), /*#__PURE__*/_jsxs(UIDescriptionList, {
      children: [label && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("dt", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-formula-editor.formula-editor.token.label"
          })
        }), /*#__PURE__*/_jsx("dd", {
          children: label
        })]
      }), type && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("dt", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-formula-editor.formula-editor.token.type"
          })
        }), /*#__PURE__*/_jsx("dd", {
          children: /*#__PURE__*/_jsx(Code, {
            children: type
          })
        })]
      }), name && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("dt", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-formula-editor.formula-editor.token.name"
          })
        }), /*#__PURE__*/_jsx("dd", {
          children: /*#__PURE__*/_jsx(Code, {
            children: name
          })
        })]
      })]
    })]
  });
};
export default TokenDescription;